export default "__VITE_ASSET__0a41cf92__"